import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { PENDING, ACTIVE, INACTIVE } from 'src/constants/listings'
import { ReactComponent as PendingIcon } from './pending-icon.svg'
import { ReactComponent as ActiveIcon } from './active-icon.svg'
import { ReactComponent as InactiveIcon } from './inactive-icon.svg'

import styles from './StatusBadge.module.scss'

const statuses = {
  [PENDING]: {
    icon: PendingIcon,
    text: () => (
      <FormattedMessage id='Listings.status.pending' defaultMessage='Pending' />
    ),
  },
  [ACTIVE]: {
    icon: ActiveIcon,
    text: () => (
      <FormattedMessage
        id='Listings.status.active'
        defaultMessage='Available'
      />
    ),
  },
  [INACTIVE]: {
    icon: InactiveIcon,
    text: () => (
      <FormattedMessage
        id='Listings.status.inactive'
        defaultMessage='Inactive'
      />
    ),
  },
}

const StatusBadge = ({ status, size = 'xs' }) => {
  if (!statuses[status]) {
    return null
  }

  const { icon: StatusIcon, text: StatusText } = statuses[status]

  return (
    <div className={classnames(styles.badge, size && [`badge--${size}`])}>
      <div className={styles.leadingVisual}>
        <StatusIcon />
      </div>
      <span>
        <StatusText />
      </span>
    </div>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['pending', 'active', 'inactive']),
  size: PropTypes.oneOf(['xs']),
}

export default StatusBadge
